import { CardActionPassword } from "@/components/Cards/View/Details/Actions/Password"
import { isRainProvider } from "@/constants/ProviderConstants"
import { useStoreCardView } from "@usher/pe-client-front-end-lib"

export const CardDetailsActions = () => {
  const { provider_id } = useStoreCardView((store) => store.card)
  const hideChangePin = !isRainProvider(provider_id)
  return <div className="main-content_list-btn [&>button]:flex-shrink-0">{!hideChangePin && <CardActionPassword />}</div>
}
